export class DropDownItem {
    constructor(
        public ITEM_ID: string,
        public ITEM_TEXT: string
    ) { }
}
